import { Slider } from "@/components/ui/slider";

interface GoalsStepProps {
  value: number;
  onChange: (value: number) => void;
}

export const GoalsStep = ({ value, onChange }: GoalsStepProps) => {
  const handleValueChange = (values: number[]) => {
    onChange(values[0]);
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold font-nexa">Your Goals with Nimi</h2>
      <p className="text-muted-foreground">What brings you to Nimi?</p>
      <div className="space-y-8">
        <Slider
          value={[value]}
          onValueChange={handleValueChange}
          max={100}
          step={1}
        />
        <div className="flex justify-between text-sm text-muted-foreground">
          <span>Meeting new people</span>
          <span>Experience more of the arts</span>
        </div>
      </div>
    </div>
  );
};